const defaultCTAPropsMap : any = {
  en: {
    text: "Your greatest work",
    highlightedText: "is just on the horizon",
    btnHref: "https://auth.upsun.com/register/",
    btnText: "Free trial"
  },
  es: {
    text: "Tu mejor trabajo",
    highlightedText: "esta justo en el horizonte",
    btnHref: "https://auth.upsun.com/register/",
    btnText: "Prueba gratuita"
  },
  de: {
    text: "Ihr größtes Werk",
    highlightedText: "steht vor der Tür",
    btnHref: "https://auth.upsun.com/register/",
    btnText: "Kostenloser Test"
  },
  fr: {
    text: "Votre meilleur travail",
    highlightedText: "est à l'horizon",
    btnHref: "https://auth.upsun.com/register/",
    btnText: "Essai gratuit"
  }
};

export { defaultCTAPropsMap }